
<h1 mat-dialog-title class="col-md-12 printPageButton" style="text-align: center !important;"> 
  <button  mat-raised-button
  color="primary" class="printPageButton" (click)="onNoClick()">Close</button>
   <button  mat-raised-button
  color="primary" class="printPageButton" (click)="OnConfirmItems()">Save</button> 
  <button  mat-raised-button
  color="primary" class="printPageButton" (click)="onExport()">PDF</button> 
  <button  mat-raised-button
  color="primary" class="printPageButton" (click)="onoculta()">Hide QTY</button> 
 
</h1>

<div mat-dialog-content>
  <div>
    <div *ngIf="viewTable" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="
    width: 100%;
    overflow: auto;
  ">
      <div class="panel panel-default"  #pdfTable3>
        <!-- Default panel contents -->
        <div class="panel-heading">CONTAINER# {{data.container.ContainerNumber}}</div>
        <div class="panel-body">
          <p>Arrived:{{data.container.Arrived}}</p>
          <p>Reference#:{{data.container.ReferenceNumber}}</p>
          <p>PO#:{{data.container.po}}</p>
        </div>
      
        <!-- Table -->
        <table class="table">
  <thead>
    <tr>
      <th style="border: 1px solid !important;">LOCATION</th>
      <th style="border: 1px solid !important;">ITEM NUMBER</th>
      <th style="border: 1px solid !important;">PIECES</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th  style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      
      
      <th style="border: 1px solid !important;">QTY</th>
      <th style="border: 1px solid !important;">PLT#</th>
      <th style="border: 1px solid !important;">PLT</th>
      <th style="border: 1px solid !important;">QTY</th>
    
      <th style="border: 1px solid !important;">QTY EXP.</th>
     </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of arrayIte; let i=index">
      <td style="border: 1px solid !important;width: 60px;" >{{onCleaarte(data.container.Customer)}}</td>
      <td style="border: 1px solid !important;width: 60px;" > {{item.ItemNumber}}</td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.NumberInMaster" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto1" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl1" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty1" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto2" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl2" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty2" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto3" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl3" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty3" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto4" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl4" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty4" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto5" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl5" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty5" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto6" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl6" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty6" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto7" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl7" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty7" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto8" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl8" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty8" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto9" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl9" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty9" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto10" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl10" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty10" type="number">
        </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.pto11" type="number">
      </mat-form-field>
      </td>
      <td style="border: 1px solid !important;width: 60px;" > 
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
        <mat-label></mat-label>
        <input matInput [(ngModel)]="item.ptl11" type="number">
      </mat-form-field>
      
      </td>
      <td style="border: 1px solid !important;width: 60px;" >
        <mat-form-field appearance="fill" *ngIf="ocultarT" style="width: 120px !important;" >
          <mat-label></mat-label>
          <input matInput [(ngModel)]="item.qty11" type="number">
        </mat-form-field>
      
      </td>
   
      <td style="border: 1px solid !important;width: 60px;" >{{item.qtyexp}}</td>
    </tr>
    <tr>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" > </td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;"></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      
      <td style="border: 1px solid !important;width: 60px;" > </td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;"></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" ></td>
      <td style="border: 1px solid !important;width: 60px;" >TOTAL</td>
      <td style="border: 1px solid !important;width: 60px;" >{{totalTable}}</td>
    </tr>
  </tbody>
        </table>
      </div>
    </div>
   <div *ngIf="false" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12" style="height: 50vh;overflow: auto;">
    <div *ngFor="let item of data.arrayitems; let i=index">
      <P class="col-md-12" *ngIf="item.Active==1">
        Item Number: {{item.ItemNumber}} <br>
        Weight:{{item.weightTotal}} <br>
        Quantity: {{item.Quantity}} <br>
        PRO#: {{item.proNumber}}
      </P>
     
     
         
          <mat-form-field *ngIf="item.Active==1" appearance="fill"  class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <mat-label>receive Quantity</mat-label>
            <input matInput [(ngModel)]="item.receiveQuantity" type="number">
          </mat-form-field>
          <mat-form-field *ngIf="item.Active==1" appearance="fill"  class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
            <mat-label>pallet Quantity</mat-label>
            <input matInput [(ngModel)]="item.palletQuantity" type="number">
          </mat-form-field>
     </div>
   </div>
 
   
  </div>

</div>

<ngx-spinner
  bdColor="rgba(0,0,0,0.07)"
  size="medium"
  color="#2879ff"
  type="square-jelly-box"
  [fullScreen]="true"
>
</ngx-spinner>